/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Compare_Row_License_AcInputs */

const en_cad_compare_row_license_ac = /** @type {(inputs: Cad_Compare_Row_License_AcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proprietary`)
};

/**
* | output |
* | --- |
* | "Proprietary" |
*
* @param {Cad_Compare_Row_License_AcInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_compare_row_license_ac = /** @type {((inputs?: Cad_Compare_Row_License_AcInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Compare_Row_License_AcInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_compare_row_license_ac(inputs)
});
export { cad_compare_row_license_ac as "cad.compare.row_license_ac" }